/* eslint-disable @typescript-eslint/no-shadow */
import styled from 'styled-components'
import { SvgIcon, IconFont } from '@/components'

import { useState, useCallback, useEffect } from 'react'

import { MailOutlined } from '@ant-design/icons'
import { useSearchParams } from 'react-router-dom'
import { CustomTabs } from '@/components/custom-tabs'
import { t } from '@/i18n'

interface MenuItemProps {
  isActive: boolean
  show: boolean
}
interface ContentLayoutProps {
  menuList: {
    key: string
    label: string
    component: React.ReactNode
    show?: boolean
    name?: string
  }[]
  children: JSX.Element | JSX.Element[]
  rightSlot?: React.ReactNode
  showDescribe?: boolean
}

export const ContentLayout = (props: ContentLayoutProps) => {
  const [collapsed, setCollapsed] = useState(false)
  interface MenuStructure {
    label: string
    level?: number
    pathName?: string
    key?: string
    path?: string
    children?: MenuStructure[]
    icon?: React.ReactNode
  }
  // 处理子菜单项
  const processSubMenuItems = (menuInfo): MenuStructure[] => {
    if (!menuInfo?.props?.children) return []

    const children = menuInfo.props.children
    const processChild = (child): MenuStructure => {
      if (child.props.subMenuItems) {
        return {
          label: child.props.text,
          // level: child.props.level,
          // pathName: child.props.pathName,
          key: child.props.to,
          path: child.props.to,
          icon: <MailOutlined />,
          children: child.props.subMenuItems
            ? processSubMenuItems(child.props.subMenuItems)
            : undefined,
        }
      }
      return {
        label: child.props.text,
        // level: child.props.level,
        // pathName: child.props.pathName,
        key: child.props.to,
        path: child.props.to,
        icon: <MailOutlined />,
      }
    }

    if (Array.isArray(children)) {
      return children.filter(child => child?.props && child.props.show !== false).map(processChild)
    }

    return children?.props && children.props.show !== false ? [processChild(children)] : []
  }

  const { menuList, children, rightSlot } = props

  // 获取当前路由对应的菜单项

  return (
    <ContentLayoutContainer>
      <ContentContainer collapsed={collapsed}>
        <div className="content-container">
          {menuList.length > 0 ? (
            <div className="tab-box">
              <CustomTabs items={menuList} rightSlot={rightSlot} />
            </div>
          ) : (
            <div className="content-box">{children}</div>
          )}
        </div>
      </ContentContainer>
    </ContentLayoutContainer>
  )
}

const ContentLayoutContainer = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
`

const SiderContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  /* border-top: 0.5px solid #F0F2F5; */
  width: 100%;
  height: 48px;
  display: flex;
  background: #ffffff;
  .menu {
    width: 100%;
    display: flex;
    margin-left: 374px;
  }

  .description {
    flex-shrink: 0;
    line-height: 48px;

    display: flex;
    margin-right: 20px;

    span {
      color: #666;
      cursor: pointer;

      &:hover {
        color: #4238c9;
      }
    }
  }

  .botton {
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }
`

const DecorateImg = styled.img`
  position: absolute;
  top: -1px;
  width: 100%;
  height: 3px;
  z-index: 99;
`

const StyledMenuItem = styled.div<MenuItemProps>`
  height: 48px;
  cursor: pointer;
  color: ${props => (props.isActive ? '#4238C9 !important' : '#333333')};
  background-color: ${props => (props.isActive ? '#fff' : 'transparent')};
  font-weight: 500;
  margin: 0 24px;
  line-height: 48px;
  position: relative;
  z-index: 0;
  border-bottom: 3px solid transparent;
  border-color: ${props => (props.isActive ? '#4238C9' : 'transparent')};
  display: ${props => (props.show ? 'block' : 'none')};
  .menu-list {
    display: flex;
    align-items: center;
    &:hover {
      color: #333333;
    }
    margin-left: 0;
    &::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 18px;
      border-right: 1px solid #d9d9d9;
      position: absolute;
      right: -24px;
      top: 15px;
    }
  }
  &:hover {
    color: #4238c9;
  }
`

const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  overflow-y: scroll;
  display: flex;
  flex-direction: row;
  .menu-box {
    width: ${props => (props.collapsed ? '56px' : '200px')};
    transition: width 0.3s ease;
    height: 100%;
    background: linear-gradient(180deg, #0f065a 0%, #080039 100%);
    .collapse-box {
      display: flex;
      align-items: center;
      padding: 6px 8px;
      .btn {
        width: 100%;
        height: 30px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 6px;
      }
    }
    .ant-menu.ant-menu-inline {
      background: transparent;
    }
    .ant-menu.ant-menu-vertical {
      background: none;
    }
    .ant-menu.ant-menu-vertical .ant-menu-submenu-popup {
      background: #070035;
    }
    .ant-menu-item {
      height: 48px;
      line-height: 48px;
    }
    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
      background: linear-gradient(90deg, #342bb8 0%, rgba(32, 144, 168, 0.8) 100%);
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: linear-gradient(180deg, #9f98ff 0%, #30a1b9 100%);
      }
    }
    .ant-menu.ant-menu-inline-collapsed {
      width: 56px;
    }
  }
  .content-container {
    flex: 1;
    height: 100%;
    width: 100%;
    .tab-box {
      width: 100%;
      height: 35px;
      background: #f1f3f5;
      .description {
        height: 35px;
        line-height: 35px;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right: 20px;
        span {
          color: #666;
          cursor: pointer;

          &:hover {
            color: #4238c9;
          }
        }
      }
    }
    .content-box {
      width: 100%;
      height: 100%;
    }
  }
`
const Icon = styled(IconFont)`
  width: 14px;
  height: 14px;
  margin-right: 10px;
  display: inline-block;
`
const Svg = styled(SvgIcon)`
  width: 14px;
  height: 14px;
  margin-right: 10px;
  display: inline-block;
`

const TabContainer = styled.div`
  background: #fff;
  padding: 16px;
  margin: 16px;
  border-radius: 4px;
`

const TabContent = styled.div`
  margin-top: 16px;
`
